// @flow
import React from 'react';
import * as RenterApp from 'styles/Home/StyledRenterApplication';
import _ from 'lodash';
import OptionList from 'models/OptionList';
import BackButton from 'components/renter_application/BackButtonComponent';
import ScreeningParamsActions from 'actions/ScreeningParamsActions';
import ScreeningParamsStore from 'stores/ScreeningParamsStore';
import InputComponent from 'components/shared/InputComponent';
import InputMaskedComponent from 'components/shared/InputMaskedComponent';
import CheckOptionForm from 'components/shared/CheckOptionFormComponent';
import YesNoOption from 'components/shared/YesNoOptionComponent';
import NumberInputForm from 'components/shared/NumberInputFormComponent';
import MoneyInput from 'components/shared/MoneyInputComponent';
import * as Layout from 'styles/Layout';
import * as Validations from 'validations/HomieValidations';
import SelectComponent from 'components/shared/SelectComponent';
import HomieContext from 'HomieContext';
import InputCodePhone from 'components/shared/InputPhoneCode';
import styled from 'styled-components';
import Spinner from 'components/shared/Spinner';
import { NATURAL_PERSON_CONST } from 'utils/Constants';

const StyledForm = styled.form`
  padding-top: ${props => (props.addPadding ? 70 : 0)}px;
`;

const BackButtonContainer = styled(RenterApp.BackButtonContainer)`
  margin-top: ${props => (props.addMargin ? 20 : 0)}px;
  margin-left: ${props => (props.addMargin ? 20 : 0)}px;
`;

type PropsType = {
  homeApplication: any,
  handleChange?: () => void,
  updateHomeApplication: (any, any) => void,
  nextAction: () => void,
  onPrevStep: () => void,
  onChange: (any, any) => void,
  onCancel: () => void,
  isForAdvisor?: boolean,
  spinnerVisible?: boolean,
  isOnlyEditIncome: boolean,
  setScroll?: () => void,
  color?: string
};

type StateType = {
  home_application_income: {
    credit_card_last_digits: string,
    credit_card_issued_months: number,
    number_of_homies: number,
    position: string,
    income_source: string,
    everybodys_income: string,
    credit_card: boolean,
    automotive_credit: boolean,
    mortgage_credit: boolean,
    other_credits: boolean,
    company: {
      business_name: string,
      company_business_role: string
    },
    homies: Array<any>
  },
  positionTypes: Array<OptionList>,
  incomeSources: Array<OptionList>,
  cardTimes: Array<OptionList>,

  creditHistory: [],
  countryCode: number,
  pickingCountryCode: boolean,
  mortgageCredit: boolean,
  automotiveCredit: boolean,
  debitCard: boolean,
  dividedRentPayment: boolean,
  generalError: number | boolean,
  saving: boolean,
  optionsChecked: []
};

class EarningsContent extends React.Component<PropsType, StateType> {
  static defaultProps = {
    isForAdvisor: false
  };

  state = {
    home_application_income: this.defaultValues.home_application_income,
    positionTypes: [],
    incomeSources: [],
    cardTimes: this.defaultValues.cardTimes,

    creditHistory: this.defaultValues.creditHistory,
    countryCode: 52,
    pickingCountryCode: false,
    mortgageCredit: false,
    automotiveCredit: false,
    debitCard: false,
    dividedRentPayment: this.defaultValues.dividedRentPayment
      ? this.defaultValues.dividedRentPayment
      : null,
    generalError: false,
    saving: false,
    optionsChecked: this.defaultValues.creditHistory
  };

  get defaultValues(): any {
    const ha = this.props.homeApplication;
    const income = ha.income;

    let homies = _.get(income, 'homies', []).map(homie => {
      if (!_.get(homie, 'pickingCountryCode')) {
        _.set(homie, 'pickingCountryCode', false);
      }
      if (!_.get(homie, 'phone_country_code')) {
        _.set(homie, 'phone_country_code', 52);
      }
      if (!_.get(homie, 'mobile_phone')) {
        _.set(homie, 'mobile_phone', '');
      }
      return homie;
    });

    let creditHistory = [];
    if (_.get(income, 'mortgage_credit')) {
      creditHistory.push('mortgage_credit');
    }
    if (_.get(income, 'credit_card')) {
      creditHistory.push('credit_card');
    }
    if (_.get(income, 'automotive_credit')) {
      creditHistory.push('automotive_credit');
    }
    if (_.get(income, 'other_credits')) {
      creditHistory.push('other_credits');
    }

    let dividedRentPayment = _.get(income, 'number_of_homies');
    if (!_.isNil(dividedRentPayment)) {
      dividedRentPayment = dividedRentPayment > 0;
    }

    return {
      home_application_income: {
        credit_card_last_digits: _.get(income, 'credit_card_last_digits'),
        credit_card_issued_months: _.get(income, 'credit_card_issued_months'),
        number_of_homies: _.get(income, 'number_of_homies'),
        position: _.get(income, 'position'),
        income_source: _.get(income, 'income_source'),
        everybodys_income: _.get(income, 'everybodys_income'),
        company: {
          business_name: _.get(income, 'company.business_name') || '',
          company_business_role:
            _.get(income, 'company.company_business_role') || ''
        },
        homies
      },
      creditHistory,
      cardTimes: NATURAL_PERSON_CONST.CARD_TIMES,
      dividedRentPayment
    };
  }

  componentWillMount = () => {
    ScreeningParamsStore.addChangeListener(this.onScreeningPositionTypesChange);
    ScreeningParamsStore.addChangeListener(this.onScreeningIncomeSourceChange);
  };

  componentWillUnmount = () => {
    ScreeningParamsStore.removeChangeListener(
      this.onScreeningPositionTypesChange
    );
    ScreeningParamsStore.removeChangeListener(
      this.onScreeningIncomeSourceChange
    );
  };

  componentDidMount = () => {
    ScreeningParamsActions.getScreeningParams({ name: 'position_types' });
    ScreeningParamsActions.getScreeningParams({ name: 'income_sources' });
  };

  onScreeningPositionTypesChange = () => {
    const positionTypes = this.getScreeningParams('position_types');
    this.setState({ positionTypes });
  };

  onScreeningIncomeSourceChange = () => {
    const incomeSources = this.getScreeningParams('income_sources');
    this.setState({ incomeSources });
  };

  getScreeningParams = (type: string) => {
    return ScreeningParamsStore.getScreeningParam(type).map(screeningParam => ({
      value: screeningParam.slug,
      label: screeningParam.name
    }));
  };

  onValidChange = (value: string, path: string) => {
    this.setState(prevState => {
      _.set(prevState, path, value);
      return prevState;
    });
  };

  onCreditHistoryChange = (values: string | Array<string>) => {
    let cardSelected = false;
    this.setState(prevState => {
      _.set(prevState, 'home_application_income.credit_card', false);
      _.set(prevState, 'home_application_income.automotive_credit', false);
      _.set(prevState, 'home_application_income.mortgage_credit', false);
      _.set(prevState, 'home_application_income.other_credits', false);

      for (let i = 0; i < values.length; i++) {
        _.set(prevState, `home_application_income.${values[i]}`, true);
        if (values[i] === 'credit_card') cardSelected = true;
      }

      if (!cardSelected) {
        _.set(
          prevState,
          `home_application_income.credit_card_issued_months`,
          null
        );
        _.set(prevState, `home_application_income.credit_card_last_digits`, '');
      }

      return prevState;
    });

    this.setState({ optionsChecked: values });
  };

  executeValidations = () => {
    document.querySelectorAll('form input, .validated').forEach(el => {
      el.focus();
      el.blur();
    });
  };

  resolveAfter = async (): Promise<any> => {
    return new Promise(resolve => {
      setTimeout(() => {
        const form = document.forms[0];
        const errors = form.querySelectorAll('.error-message');
        if (errors.length > 0) {
          errors[0].parentElement.scrollIntoView(false);
        }
        resolve(errors.length);
      }, 250);
    });
  };

  isFieldsValidated = async (): Promise<boolean> => {
    let rErrors = await this.resolveAfter();
    return rErrors === 0;
  };

  handleSubmit = async (event: any): Promise<any> => {
    event.preventDefault();
    this.setState({ saving: true });
    this.executeValidations();
    let valid = await this.isFieldsValidated();
    const { isForAdvisor } = this.props;
    if (valid) {
      if (!isForAdvisor) {
        this.context.showLoadingProcessView('Guardando tu información');
      }
      setTimeout(() => {
        this.syncHomiesCount(() => {
          this.props.onChange(this.serializeState());
        });
      }, 900);
    } else {
      let error = true;
      this.setState(
        {
          generalError: error
        },
        () => {
          this.isContainerScroll(isForAdvisor);
        }
      );
    }
  };

  isContainerScroll = (status: boolean) => {
    if (status) {
      this.props.setScroll();
    }
  };

  hasCreditCard = (): boolean => {
    const { home_application_income } = this.state;

    return (
      home_application_income.credit_card ||
      home_application_income.credit_card_issued_months ||
      home_application_income.credit_card_last_digits
    );
  };

  serializeState = (): {} => {
    return {
      home_application_income: _.get(this.state, 'home_application_income'),
      step: 'income'
    };
  };

  syncHomiesCount = (callback: Function) => {
    this.setState(prevState => {
      const dividedRent = _.get(prevState, 'dividedRentPayment');
      let totalHomies = [];
      if (dividedRent) {
        const homies = _.get(prevState, 'home_application_income.homies');
        const number_of_homies = _.get(
          prevState,
          'home_application_income.number_of_homies'
        );
        totalHomies = _.take(homies, number_of_homies);
      } else {
        _.set(prevState, 'home_application_income.number_of_homies', 0);
      }
      _.set(prevState, 'home_application_income.homies', totalHomies);
      return prevState;
    }, callback);
  };

  homieIsPickingCountryCode = (
    index: number,
    isPicking: boolean,
    code?: number
  ) => {
    this.setState(prevState => {
      const path = `home_application_income.homies.${index}.pickingCountryCode`;
      _.set(prevState, path, isPicking);
      if (!isPicking) {
        const path = `home_application_income.homies.${index}.phone_country_code`;
        _.set(prevState, path, code);
      }
      return prevState;
    });
  };

  getDisabledFields = () => {
    const { optionsChecked } = this.state;

    if (optionsChecked.length === 0) return [];

    return NATURAL_PERSON_CONST.CREDIT_HISTORY_OPTIONS.filter(({ id }) =>
      optionsChecked.includes('other_credits')
        ? id !== 'other_credits'
        : id === 'other_credits'
    ).map(({ id }) => id);
  };

  renderButton = () => {
    const { isForAdvisor, spinnerVisible, isOnlyEditIncome } = this.props;
    const submitText = isOnlyEditIncome ? 'Guardar' : 'Siguiente';
    if (isForAdvisor) {
      return !spinnerVisible ? (
        <RenterApp.SubmitButton type="submit">
          {submitText}
        </RenterApp.SubmitButton>
      ) : null;
    }
    return (
      <RenterApp.SubmitButton type="submit">
        {submitText}
      </RenterApp.SubmitButton>
    );
  };

  renderSpinner = () => {
    const { isForAdvisor, spinnerVisible, color } = this.props;
    return isForAdvisor && spinnerVisible && <Spinner color={color} />;
  };

  renderWhereDoYouWork = (isForAdvisor: boolean) => {
    if (isForAdvisor) {
      return null;
    }

    return <RenterApp.Title>¿Dónde trabajas?</RenterApp.Title>;
  };

  getDateOfBirth = (date: string): string => {
    return _.isNil(date)
      ? ''
      : date.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1');
  };

  limitFourDigit = text => {
    return text.replace(/[^0-9]/g, '').substring(0, 4);
  };

  renderDividedRentPayment = (
    dividedRentPayment: boolean,
    home_application_income: any,
    number_of_homies: number
  ) => {
    if (dividedRentPayment !== true) {
      return null;
    }

    return (
      <div>
        <RenterApp.EndSectionSpace />
        <RenterApp.Title>¿Con cuántas personas?</RenterApp.Title>
        <NumberInputForm
          name="home_application_income.number_of_homies"
          value={number_of_homies}
          minNumber={1}
          maxNumber={20}
          onValueChange={this.onValidChange}
          color={this.props.color}
        />
        <RenterApp.EndSectionSpace />
        {_.times(number_of_homies, index => (
          <div key={index}>
            <Layout.FlexColumn>
              <RenterApp.Title>Datos de la persona {index + 1}</RenterApp.Title>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.name`}
                  placeholder="Nombre(s)"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.name`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.RequiredNameSchema}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.last_name`}
                  placeholder="Primer apellido"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.last_name`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.RequiredNameSchema}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.second_last_name`}
                  placeholder="Segundo apellido"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.second_last_name`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.NameSchema}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.StyledValidatedInput>
                <InputMaskedComponent
                  name={`home_application_income.homies.${index}.date_of_birth`}
                  placeholder="dd / mm / aaaa"
                  value={this.getDateOfBirth(
                    _.get(
                      home_application_income,
                      `homies.${index}.date_of_birth`,
                      ''
                    )
                  )}
                  schema={Validations.ageSchema}
                  onValueChange={this.onValidChange}
                  mask="11/11/1111"
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.StyledOptionalInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.rfc`}
                  placeholder="RFC"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.rfc`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.RFCSchema}
                />
                <RenterApp.StyledInputInstructions>
                  Si eres extranjero este campo no es necesario
                </RenterApp.StyledInputInstructions>
              </RenterApp.StyledOptionalInput>
              <RenterApp.StyledValidatedInput>
                <InputCodePhone
                  type="text"
                  placeholder="Teléfono"
                  name={`home_application_income.homies.${index}.mobile_phone`}
                  value={_.get(
                    home_application_income,
                    `homies.${index}.mobile_phone`
                  )}
                  pickingCountryCode={_.get(
                    home_application_income,
                    `homies.${index}.pickingCountryCode`
                  )}
                  countryCode={_.get(
                    home_application_income,
                    `homies.${index}.phone_country_code`,
                    52
                  )}
                  handleCountryCodeClick={() => {
                    this.homieIsPickingCountryCode(index, true);
                  }}
                  handleCountryCodePicked={(el: any) => {
                    this.homieIsPickingCountryCode(index, false, +el.value);
                  }}
                  onValueChange={this.onValidChange}
                  schema={Validations.PhoneNumberSchema}
                ></InputCodePhone>
              </RenterApp.StyledValidatedInput>
              <MoneyInput
                textAlign="left"
                name={`home_application_income.homies.${index}.income_amount`}
                value={_.get(
                  home_application_income,
                  `homies.${index}.income_amount`,
                  ''
                )}
                schema={Validations.RequiredMoneyFieldSchema}
                isValidated
                onValueChange={this.onValidChange}
                currency="MXN"
                currencySign="$"
                placeholder="Ingresos mensuales netos"
              />

              <RenterApp.EndSectionSpace />
              <RenterApp.Title>
                Dirección de la persona {index + 1}
              </RenterApp.Title>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.address.street`}
                  placeholder="Calle"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.address.street`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.RequiredFieldSchema}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.RowInputsContainer>
                <RenterApp.RowStyledInputContainer>
                  <RenterApp.StyledValidatedInput>
                    <InputComponent
                      type="text"
                      name={`home_application_income.homies.${index}.address.ext_number`}
                      placeholder="Número ext"
                      value={_.get(
                        home_application_income,
                        `homies.${index}.address.ext_number`,
                        ''
                      )}
                      onValueChange={this.onValidChange}
                      schema={Validations.RequiredExtNumberSchema}
                    />
                  </RenterApp.StyledValidatedInput>
                </RenterApp.RowStyledInputContainer>
                <Layout.Spacer />
                <RenterApp.RowStyledInputContainer>
                  <RenterApp.StyledOptionalInput>
                    <InputComponent
                      type="text"
                      name={`home_application_income.homies.${index}.address.int_number`}
                      placeholder="Número int"
                      value={_.get(
                        home_application_income,
                        `homies.${index}.address.int_number`,
                        ''
                      )}
                      onValueChange={this.onValidChange}
                      schema={Validations.IntNumberSchema}
                    />
                  </RenterApp.StyledOptionalInput>
                </RenterApp.RowStyledInputContainer>
              </RenterApp.RowInputsContainer>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.address.neighborhood`}
                  placeholder="Colonia"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.address.neighborhood`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.ValidateOnlyTextAndNumber}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.address.town`}
                  placeholder="Delegación / Municipio"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.address.town`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.ValidateOnlyTextAndNumber}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.address.state`}
                  placeholder="Estado"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.address.state`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.ValidateOnlyTextAndNumber}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.StyledValidatedInput>
                <InputComponent
                  type="text"
                  name={`home_application_income.homies.${index}.address.zip`}
                  placeholder="Código postal"
                  value={_.get(
                    home_application_income,
                    `homies.${index}.address.zip`,
                    ''
                  )}
                  onValueChange={this.onValidChange}
                  schema={Validations.CPSchema}
                />
              </RenterApp.StyledValidatedInput>
              <RenterApp.EndSectionSpace />
            </Layout.FlexColumn>
          </div>
        ))}
      </div>
    );
  };

  renderCreditCard = (home_application_income: any, cardTimes: any) => {
    if (!this.hasCreditCard()) return null;
    return (
      <>
        <RenterApp.StyledValidatedInput>
          <InputComponent
            name="home_application_income.credit_card_last_digits"
            value={this.limitFourDigit(
              home_application_income.credit_card_last_digits
            )}
            type="text"
            placeholder="Ingresa los últimos 4 dígitos de tu tarjeta"
            onValueChange={this.onValidChange}
            schema={Validations.cardFourNumberSchema}
          />
          <RenterApp.StyledErrorMessage
            name="credit_card_last_digits"
            component="div"
          />
        </RenterApp.StyledValidatedInput>
        <SelectComponent
          name="home_application_income.credit_card_issued_months"
          minSize={5}
          placeholder="Tiempo con la tarjeta"
          options={cardTimes}
          value={home_application_income.credit_card_issued_months}
          isSearchable={false}
          onValueChange={this.onValidChange}
          schema={Validations.RequiredFieldSchema}
        />
      </>
    );
  };

  renderButtonCancelApplication = () => {
    const { color, isForAdvisor, onCancel } = this.props;

    return (
      !isForAdvisor && (
        <RenterApp.CancelAppButton color={color} onClick={onCancel}>
          Cancelar aplicación
        </RenterApp.CancelAppButton>
      )
    );
  };

  render() {
    const {
      home_application_income,
      creditHistory,
      cardTimes,
      dividedRentPayment,
      saving
    } = this.state;
    const { isForAdvisor, isOnlyEditIncome, color } = this.props;
    const number_of_homies = home_application_income.number_of_homies || 1;

    return (
      <RenterApp.AppTabContainer>
        {!isOnlyEditIncome && (
          <BackButtonContainer
            onClick={this.props.onPrevStep}
            addMargin={isForAdvisor}
          >
            <BackButton text="Perfil" color={color} />
          </BackButtonContainer>
        )}
        <RenterApp.AppTabForm>
          <StyledForm onSubmit={this.handleSubmit} addPadding={isForAdvisor}>
            <RenterApp.EndSectionSpace />
            <RenterApp.Title>Historial crediticio</RenterApp.Title>
            <RenterApp.Description>
              Consultamos tu historial crediticio para conocer el comportamiento
              de tus finanzas y garantizar una renta sin aval.
            </RenterApp.Description>
            <CheckOptionForm
              name=""
              options={NATURAL_PERSON_CONST.CREDIT_HISTORY_OPTIONS}
              value={creditHistory}
              isValidated
              saving={saving}
              onValueChange={this.onCreditHistoryChange}
              disabledFields={this.getDisabledFields()}
              color={color}
            />
            {this.renderCreditCard(home_application_income, cardTimes)}
            <RenterApp.EndSectionSpace />
            <RenterApp.Title>
              ¿Vas a dividir el pago de la renta?
            </RenterApp.Title>
            <YesNoOption
              name="dividedRentPayment"
              value={dividedRentPayment}
              onValueChange={this.onValidChange}
              color={color}
            />
            {this.renderDividedRentPayment(
              dividedRentPayment,
              home_application_income,
              number_of_homies
            )}
            <RenterApp.EndSectionSpace />

            <RenterApp.Title>Fuente de ingresos</RenterApp.Title>
            <SelectComponent
              name="home_application_income.income_source"
              minSize={3}
              placeholder="Seleccione una opción"
              options={this.state.incomeSources}
              value={home_application_income.income_source}
              isSearchable={false}
              onValueChange={this.onValidChange}
              schema={Validations.RequiredFieldSchema}
            />

            <RenterApp.EndSectionSpace />
            <RenterApp.Title>Ingresos mensuales netos</RenterApp.Title>
            <MoneyInput
              textAlign="left"
              name="home_application_income.everybodys_income"
              value={home_application_income.everybodys_income}
              onValueChange={this.onValidChange}
              schema={Validations.RequiredMoneyMonthlyIncome}
              isValidated
              currency="MXN"
              currencySign="$"
            />
            <RenterApp.EndSectionSpace />
            {this.renderButton()}
            {this.renderSpinner()}
          </StyledForm>
        </RenterApp.AppTabForm>
        {!isOnlyEditIncome && this.renderButtonCancelApplication()}
      </RenterApp.AppTabContainer>
    );
  }
}
EarningsContent.contextType = HomieContext;
export default EarningsContent;
